import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 border-2 border-foreground/20 border-t-foreground rounded-full animate-spin" />
      </div>
    );
  }
  if (!user && !location.state?.user) return <Navigate to="/" replace />;

  // Shield routes based on subscription tier for regular users
  if (user && user.role !== 'admin') {
    const tier = user.subscription_tier || '1_month';
    const path = location.pathname;
    
    if (tier === '1_month' && ["/portfolio", "/billing", "/insight"].includes(path)) {
      return <Navigate to="/dashboard" replace />;
    }
    if (tier === '6_months' && ["/insight"].includes(path)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
